import React from "react";
import { useTranslation } from "react-i18next";
import type { AdminSubStatus, AdminUserSort } from "../../../graphql/types";

interface UserFilterBarProps {
  status: AdminSubStatus;
  sort: AdminUserSort;
  onStatus: (status: AdminSubStatus) => void;
}

const STATUS_SEGMENTS: AdminSubStatus[] = ["ALL", "ACTIVE", "TRIAL", "FREE", "EXPIRED"];

/**
 * Users filter bar (FE-5): segmented Alle/Active/Trial/Expired sub-filter and
 * the current sort label (right-aligned). The former "Nur in Trial" toggle was
 * dropped — the Trial segment right next to it already does the same thing.
 */
export const UserFilterBar: React.FC<UserFilterBarProps> = ({
  status,
  sort,
  onStatus,
}) => {
  const { t } = useTranslation();

  return (
    <div className="users-filterbar">
      <div className="usf-segment">
        {STATUS_SEGMENTS.map((seg) => (
          <button
            key={seg}
            className={`usf-seg-btn${seg === status ? " usf-seg-btn--active" : ""}`}
            onClick={() => onStatus(seg)}
          >
            {t(`users.filter.${seg.toLowerCase()}`)}
          </button>
        ))}
      </div>


      <span className="usf-sortlabel">
        {t("users.filter.sortedBy", { key: t(`users.sort.${sort.toLowerCase()}`) })}
      </span>
    </div>
  );
};
